import React from 'react'
import clsx from 'clsx'
import useStyles from './FooterComponent.styles'
import { FooterComponentProps } from './FooterComponentProps'
import TikTokLogo from '../../icons/TikTokLogo'
import FacebookLogo from '../../icons/FacebookLogo'
import InstagramLogo from '../../icons/InstagramLogo'
import NeonLink from '../../utils/NeonLink'

const FooterComponent: React.FC<FooterComponentProps> = ({
  mainLinks,
  copyText,
  secondaryLinks,
  socialMedia: { facebook, instagram, tiktok }
}) => {
  const classes = useStyles()
  return (
    <div className={classes.footer}>
      <div className={classes.footerContent}>
        <div className={classes.footerRow}>
          <div className={clsx(classes.footerColumn, classes.wrap)}>
            <div className={classes.mobileFull}>
              <NeonLink className={classes.logo} />
            </div>
            {mainLinks.map(({ href, text }, index) => (
              <a key={index} href={href} className={classes.mainLink}>
                {text}
              </a>
            ))}
          </div>
          <div className={classes.footerColumn}>
            <a href={facebook} className={classes.icon}>
              <FacebookLogo />
            </a>
            <a href={tiktok} className={classes.icon}>
              <TikTokLogo />
            </a>
            <a href={instagram} className={classes.icon}>
              <InstagramLogo />
            </a>
          </div>
        </div>

        <div className={clsx(classes.footerRow, classes.wrap)}>
          <div className={clsx(classes.footerColumn, classes.mobileFull)}>
            <div className={classes.secondaryLink}>{copyText}</div>
          </div>
          <div className={classes.footerColumn}>
            {secondaryLinks.map(({ href, text }, index) => (
              <a key={index} href={href} className={classes.secondaryLink}>
                {text}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterComponent
